import { render } from "./TerritoryTable.vue?vue&type=template&id=c501bde8&scoped=true"
import script from "./TerritoryTable.vue?vue&type=script&lang=js"
export * from "./TerritoryTable.vue?vue&type=script&lang=js"

import "./TerritoryTable.vue?vue&type=style&index=0&id=c501bde8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c501bde8"]])

export default __exports__